import { useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";
import { toast } from "sonner";
import { useT } from "../lib/i18n";

export function DepositRulePanel({ vehicleId, canEdit }) {
  const { t } = useT();
  const [info, setInfo] = useState(null);
  const [form, setForm] = useState({ type: "percent", value: "" });
  const load = () => api.get(`/vehicles/${vehicleId}/deposit-rule`).then((r) => {
    setInfo(r.data);
    setForm(r.data.deposit_rule || { type: "percent", value: r.data.default_percent });
  }).catch(() => {});
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [vehicleId]);
  if (!info) return null;
  const save = async () => {
    try { await api.put(`/vehicles/${vehicleId}/deposit-rule`, form); toast.success(t("dep.saved")); load(); } catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div className="panel p-4 mt-6" data-testid="deposit-rule-panel">
      <div className="eyebrow mb-2">{t("dep.title")}</div>
      <div className="text-sm mb-3" data-testid="deposit-rule-amount">{t("dep.amount", { v: `OMR ${info.amount}`, label: info.label })}{info.deposit_rule ? "" : ` · ${t("dep.default")}`}</div>
      {canEdit && (
        <div className="flex gap-2 flex-wrap items-center">
          <select value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })} aria-label={t("dep.type")} className="h-11 rounded-lg border px-3 text-sm" data-testid="deposit-rule-type">
            <option value="percent">{t("dep.percent")}</option><option value="fixed">{t("dep.fixed")}</option>
          </select>
          <input type="number" step="0.001" value={form.value} onChange={(e) => setForm({ ...form, value: e.target.value })} aria-label={t("dep.value")} className="h-11 w-32 rounded-lg border px-3 text-sm" data-testid="deposit-rule-value" />
          <button className="btn-primary" onClick={save} data-testid="deposit-rule-save">{t("dep.save")}</button>
        </div>
      )}
    </div>
  );
}
